export default () => {
  let first_styles = ["background : #E64925", "border: 3px solid #E64925", "color: white"].join(
    ";"
  );

  console.log("%c Made by Firefly Partners | https://fireflypartners.com ", first_styles);
};
